import { idbGet, idbPut, STORES } from './database';

export interface CachedEmbedding {
  contentHash: string;
  vector: number[];
  path: string;
  text: string;
}

export async function getCachedEmbedding(contentHash: string): Promise<CachedEmbedding | undefined> {
  return idbGet<CachedEmbedding>(STORES.embeddings, contentHash);
}

export async function saveCachedEmbedding(entry: CachedEmbedding): Promise<void> {
  await idbPut(STORES.embeddings, entry);
}
